import {useCallback, useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {blockPopUp} from '../../../../gori/helpers'
import {useCancelToken} from '../../../../gori/hooks'
import {A1BatchService} from '../core/requests'

type UsePrintLabelsOptions = {
  batchId: number
  onSuccessCallback?: () => void
  onErrorCallback?: (error: any) => void
}

export const usePrintLabels = ({
  batchId,
  onSuccessCallback,
  onErrorCallback,
}: UsePrintLabelsOptions) => {
  const {newCancelToken, isCancel} = useCancelToken()
  const intl = useIntl()
  const [loading, setLoading] = useState(false)

  const printLabels = useCallback(
    async (orderIds: number[] = []) => {
      if (!batchId) return

      try {
        setLoading(true)

        const rs = await A1BatchService.printLabels(batchId, orderIds, {
          cancelToken: newCancelToken(),
        })
        const labelUrl = rs?.data?.label_url
        if (!labelUrl) {
          return toast.warning(intl.formatMessage({id: 'PRINT_LABELS_REFUNDED'}))
        }
        if (blockPopUp(labelUrl)) {
          toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
        }
        onSuccessCallback?.()
      } catch (error: any) {
        if (isCancel(error)) return
        onErrorCallback?.(error)
      } finally {
        setLoading(false)
      }
    },
    [batchId, intl, isCancel, newCancelToken, onErrorCallback, onSuccessCallback]
  )

  return {printLabels, loading}
}
